 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }/*
 * DEPRECATED! Please use client/ui/Tooltip
 */

import {useEffect, useRef} from 'react'
import {Duration} from '../types/constEnums'
import useCoords, {} from './useCoords'
import useEventCallback from './useEventCallback'
import usePortal from './usePortal'
import useTooltipPortal from './useTooltipPortal'






const useTooltip = (
  preferredMenuPosition,
  options = {}
) => {
  const delay = _nullishCoalesce(options.delay, () => ( Duration.TOOLTIP_DELAY))
  const isDisabled = !!options.disabled
  const disabledRef = useRef(isDisabled)
  useEffect(() => {
    if (isDisabled && !disabledRef.current) {
      closeTooltip()
    }
    disabledRef.current = isDisabled
  }, [isDisabled])

  const {portal, openPortal, closePortal, portalStatus, setPortalStatus} = usePortal()
  const {targetRef, originRef, coords} = useCoords(preferredMenuPosition, {portalStatus})

  const tooltipPortal = useTooltipPortal(portal, targetRef, coords, portalStatus, setPortalStatus)
  const openDelayRef = useRef()
  useEffect(() => {
    return () => {
      window.clearTimeout(openDelayRef.current)
    }
  }, [])

  const openTooltip = useEventCallback(() => {
    if (disabledRef.current) return
    window.clearTimeout(openDelayRef.current)
    openDelayRef.current = window.setTimeout(() => {
      openPortal()
    }, delay)
  })

  const closeTooltip = useEventCallback(() => {
    window.clearTimeout(openDelayRef.current)
    closePortal()
  })
  return {
    openTooltip,
    closeTooltip,
    originRef,
    tooltipPortal
  }
}

export default useTooltip
